module.exports = __webpack_public_path__ + "img/no-picture.21a581e6.png";